module.exports = __webpack_public_path__ + "static/img/introduce.cca1de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle/introduce.png
// module id = v9VF
// module chunks = 2